<template>
  <div>
    <nav-bar-home></nav-bar-home>

    <section class="terms-section">
      <div class="container">
        <div class="terms-card">
          <div v-if="loading" class="loading-wrapper">
            <div class="spinner-border text-primary" role="status"></div>
            <p class="mt-3">Loading Terms & Conditions...</p>
          </div>

          <template v-else>
            <div class="terms-header">
              <h1 v-if="term && term.heading">
                {{ term.heading }}
              </h1>
              <!-- <p class="subtitle">
                Please review the following terms and conditions carefully.
              </p> -->
            </div>

            <div
              v-if="term && term.content"
              class="terms-content"
              v-html="term.content"
            ></div>

            <div v-if="error" class="alert alert-danger mt-3">
              {{ error }}
            </div>

            <div class="text-center mt-4">
              <button class="btn btn-primary px-4" @click="$router.back()">
                ← Back
              </button>
            </div>
          </template>
        </div>
      </div>
    </section>

    <footer-section></footer-section>
  </div>
</template>

<script>
import NavBarHome from "@/components/NavBarHome.vue";
import FooterSection from "@/components/FooterSection.vue";
export default {
  components: { NavBarHome, FooterSection },
  name: "TermsPage",
  data() {
    return {
      term: null,
      loading: true,
      error: "",
    };
  },
  async created() {
    const key = this.$route.params.key || "referrars_tnc";
    try {
      const res = await this.$store.dispatch("getTermByKey", key);
      if (res && res.status == 1) {
        this.term = res.data;
      } else {
        this.error = res && res.message ? res.message : "Failed to load terms";
      }
    } catch (err) {
      console.error(err);
      this.error = "Failed to load terms";
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style scoped>
.terms-section {
  background: #f5f7fb;
  min-height: 70vh;
  padding: 60px 15px;
}

.container {
  max-width: 1000px;
}

.terms-card {
  background: #fff;
  border-radius: 16px;
  padding: 40px;
  box-shadow: 0 10px 35px rgba(0, 0, 0, 0.08);
}

.terms-header {
  text-align: center;
  margin-bottom: 30px;
  border-bottom: 1px solid #e9ecef;
  padding-bottom: 20px;
}

.terms-header h1 {
  font-size: 32px;
  font-weight: 700;
  color: #222;
  margin-bottom: 10px;
}

.subtitle {
  color: #6c757d;
  margin-bottom: 0;
  font-size: 15px;
}

.loading-wrapper {
  text-align: center;
  padding: 60px 0;
}

.terms-content {
  color: #444;
  line-height: 1.8;
  font-size: 15px;
}

.terms-content :deep(h1),
.terms-content :deep(h2),
.terms-content :deep(h3),
.terms-content :deep(h4) {
  margin-top: 25px;
  margin-bottom: 15px;
  color: #222;
  font-weight: 600;
}

.terms-content :deep(p) {
  margin-bottom: 15px;
}

.terms-content :deep(ul),
.terms-content :deep(ol) {
  padding-left: 20px;
  margin-bottom: 15px;
}

.terms-content :deep(li) {
  margin-bottom: 8px;
}

.btn-primary {
  border-radius: 30px;
  min-width: 140px;
}

/* Tablet */
@media (max-width: 768px) {
  .terms-section {
    padding: 40px 10px;
  }

  .terms-card {
    padding: 25px;
  }

  .terms-header h1 {
    font-size: 26px;
  }
}

/* Mobile */
@media (max-width: 576px) {
  .terms-card {
    padding: 20px;
    border-radius: 12px;
  }

  .terms-header h1 {
    font-size: 22px;
  }

  .subtitle {
    font-size: 14px;
  }

  .terms-content {
    font-size: 14px;
    line-height: 1.7;
  }

  .btn-primary {
    width: 100%;
  }
}
</style>
